import { SearchStatus } from 'store/commonTypes'

export const canGenerateReport = (status: SearchStatus): boolean => {
  return status === 'search_finished'
}

export const canViewReport = (status: SearchStatus): boolean => {
  return ['report_compiling', 'complete', 'report_error'].includes(status)
}

export const hasReportAccess = (status: SearchStatus): boolean => {
  return canGenerateReport(status) || canViewReport(status)
}

export const getReportLinkText = (status: SearchStatus): string | null => {
  if (canViewReport(status)) return 'View report'
  if (canGenerateReport(status)) return 'Generate report'
  return null
}
